<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Eraser" class="d-icon d-icon--eraser" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 11a.48.48 0 0 1-.191-.038.498.498 0 0 1-.162-.108l-2.15-2.15c-.681-.681-.713-1.757.008-2.416l4.792-4.792c.68-.68 1.756-.712 2.415.009l2.792 2.791c.68.681.712 1.757-.009 2.416L7.707 10H11a.5.5 0 1 1 0 1H3.5ZM1.704 7.004a.501.501 0 0 1-.02.018c-.268.241-.296.659.02.974L3.707 10h2.586L2.5 6.207l-.796.797Zm4.8-4.8c.315-.316.733-.288.975-.02a.486.486 0 0 0 .018.02l2.8 2.8c.315.315.287.733.019.974a.515.515 0 0 0-.02.018L7 9.293 3.207 5.5l3.297-3.296Z" fill="currentColor"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconEraser',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
